export default __webpack_public_path__ + "static/media/Oval.4598cb68.webp";